import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import CarouselItem from "../cItem";
import mobile from "../../assets/oppo.jpg";
const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
    paritialVisibilityGutter: 120,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
    paritialVisibilityGutter: 100,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    paritialVisibilityGutter: 30,
  },
};

const sampleData = [
  {
    bg:
      "https://images.unsplash.com/photo-1550353175-a3611868086b?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60",
    title: "Apple MacBook Air (2020)",
    detail:
      "The new MacBook Air with its M1 chip is definitely the hottest laptop at the moment. It offers an up to 3.5x faster CPU, 5x faster graphics, as well as 18 hours of battery life.",
    overlay: "rgba(60, 89, 252,0.4)",
    route: "/",
  },
  {
    bg:
      "https://images.unsplash.com/photo-1549396535-c11d5c55b9df?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=60",
    title: "Amazfit GTS 2 Mini",
    detail:
      "The GTS 2 Mini is a smaller and slimmer version of the popular GTS 2. It packs a 1.55-inch AMOLED display, NFC, up to 21 days of battery life, and is 5ATM water-resistant.",
    overlay: "rgba(74, 74, 74,0.5)",
    route: "/",
  },
  {
    bg:
      "https://images.unsplash.com/photo-1550133730-695473e544be?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60",
    title: "Honor Band 6",
    detail:
      "Compared to the previous model, Honor's newest fitness tracker is quite a step up. It has a stunning 1.47 AMOLED display with 2.5D curved glass and looks more like a smartwatch than a fitness tracker.",
    overlay: "rgba(255, 45, 224,0.5)",
    route: "/",
  },
  {
    bg:
      "https://images.unsplash.com/photo-1550167164-1b67c2be3973?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60",
    title: "Nvidia GeForce RTX 3060 Ti",
    detail:
      "Nvidia's GeForce RTX 3060 Ti is the most affordable graphics card out of the RTX range. It offers ray tracing and DLSS acceleration and is an excellent choice for 1440p gaming.",
    overlay: "rgba(255, 86, 49,0.5)",
    route: "/",
  },
  {
    bg:
      "https://images.unsplash.com/photo-1549833284-6a7df91c1f65?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60",
    title: "Honor Band 6",
    detail:
      "Compared to the previous model, Honor's newest fitness tracker is quite a step up. It has a stunning 1.47 AMOLED display with 2.5D curved glass and looks more like a smartwatch than a fitness tracker.",
    overlay: "rgba(255, 45, 224,0.5)",
    route: "/",
  },
];
// "https://images.unsplash.com/photo-1550338861-b7cfeaf8ffd8?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60",
// "https://images.unsplash.com/photo-1550223640-23097fc71cb2?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60",
// "https://images.unsplash.com/photo-1550353175-a3611868086b?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60",
// "https://images.unsplash.com/photo-1550330039-a54e15ed9d33?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60",
// "https://images.unsplash.com/photo-1549737328-8b9f3252b927?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60",
// "https://images.unsplash.com/photo-1549833284-6a7df91c1f65?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60",
// "https://images.unsplash.com/photo-1549985908-597a09ef0a7c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60",
// "https://images.unsplash.com/photo-1550064824-8f993041ffd3?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60",
// Because this is an inframe, so the SSR mode doesn't not do well here.
// It will work on real devices.

const MyCarousel = ({ deviceType }) => {
  return (
    <div style={{ margin: "30px 0px" }}>
      <Carousel
        partialVisbile
        deviceType={deviceType}
        itemClass="image-item"
        responsive={responsive}
      >
        {sampleData.slice(0, 5).map((item) => {
          return <CarouselItem item={item} />;
        })}
      </Carousel>
    </div>
  );
};

export default React.memo(MyCarousel);
